export default {
  charge:     (amount) => amount * 0.05 + 0.40,
  membership: (amount) => amount * 0.05
};
